var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBreadcrumb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.0158C3.3645 18.0158 0 14.6513 0 10.5158C0 7.99725 1.12875 6.4215 2.82375 4.83075L4.65975 3.1065L4.06575 5.55375C3.8595 6.40575 3.8055 9.00825 4.89975 10.3995C5.358 10.9823 5.96325 11.2658 6.75 11.2658C7.58025 11.2658 8.2395 10.6028 8.25 9.756C8.2605 8.91825 7.9065 8.2245 7.5315 7.491C7.1475 6.7395 6.75 5.96325 6.75 5.01975C6.75 2.9865 7.809 1.14375 7.854 1.0665L8.475 0L9.13575 1.04325C9.7725 2.0475 10.6313 2.9835 11.463 3.88875C13.2023 5.78175 15.0007 7.74075 15.0007 10.5165C15.0007 14.652 11.6363 18.0165 7.50075 18.0165L7.5 18.0158Z",
    fill: "url(#paint0_linear_159_24)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_159_24",
    x1: 7.50037,
    y1: 0,
    x2: 7.50037,
    y2: 18.0165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#760CFE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBreadcrumb);
export default __webpack_public_path__ + "static/media/icon_breadcrumb.e1ae79c2364fb4132e7d2c2547464c41.svg";
export { ForwardRef as ReactComponent };